export default __webpack_public_path__ + "static/media/1.3d7dc2d6.png";